/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */
/* eslint max-len:0 */

import { toMessages } from 'config/messages';

export default toMessages('TwoStepVerificationCard', {
  MustCompleteQuestions: 'To keep your account secure, you must complete the security questions above before disabling Two-Step Verification.',
  TwoStepVerificationEnabled: 'You are now enabled for two-step verification.'
});
